import React from 'react';
import Select from 'react-select';
import './SelectInput.css';

const SelectInput = ({ valor, funcionOnChange, listaObjetos, seleccionMultiple, placeHolder, funcionFocus, funcionBlur, alert, label, disabled, htmlForInfo }) => {
const notaCarga =  !seleccionMultiple ? {value: 1, label: (`Cargando....`)} :{}  
  return (
    <section>
      <p className="labelInput">{label}</p>
      <Select
        value={listaObjetos.length === 0 && !seleccionMultiple ? notaCarga:valor}
        onChange={funcionOnChange}
        options={listaObjetos.length === 0 ? []:listaObjetos}
        isMulti={seleccionMultiple}
        placeholder={placeHolder}
        onBlur={funcionBlur}
        onFocus={funcionFocus}
        isSearchable={false}
        className="CNSelectInput"
        classNamePrefix="CNPSelectInput"
        disabled={disabled}
        isOptionDisabled={option => option.disable === true}
        isDisabled={listaObjetos.length === 0 ? true:null}
      />
      <span className="infoInput">{htmlForInfo}</span>
      <p className="alertInput">{alert}</p>
    </section>

  )
};

export default SelectInput;